module.exports = __webpack_public_path__ + "fonts/b07e68ca-f6b5-47bd-9d55-540e832dcfab.642a31e.ttf";